import { useMemo } from 'react';
import { LanguagePackSortingField } from '../../../api/types';

const useLanguagePackSortOrder = sort =>
    useMemo(() => {
        const referenceNameSort = sort.field === LanguagePackSortingField.ReferenceName ? sort.orderValue : undefined;
        const displayNameSort = sort.field === LanguagePackSortingField.DisplayName ? sort.orderValue : undefined;
        const internationalCodeSort =
            sort.field === LanguagePackSortingField.InternationalCode ? sort.orderValue : undefined;

        return {
            referenceNameSort,
            displayNameSort,
            internationalCodeSort,
        };
    }, [sort]);

export default useLanguagePackSortOrder;
